export default "__VITE_ASSET__BOhN8Hi9__"